import { render, staticRenderFns } from "./ViewTaxPage.vue?vue&type=template&id=095266f8"
import script from "./ViewTaxPage.vue?vue&type=script&lang=js"
export * from "./ViewTaxPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports